import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";
import { useNavigate } from "react-router-dom";

export default function GuardianPhoneScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const navigate = useNavigate();
    
    const isFormValid = flowData.phone.trim() !== "";

    const guardian = flowData?.guardian || {};
    const child = flowData?.child || {};
    const childFullName = [
        child.firstName,
        child.lastName
    ].filter(Boolean).join(" ");    

    const validate = () => {
        if (!flowData.phone.trim()) {
            return "Please enter your phone number.";
        }

        if (!/^\d{10}$/.test(flowData.phone)) {
            return "Please enter a valid 10-digit phone number.";
        }

        return false;
    };


    const continueToNext = () => {
        if (loading || !isFormValid) return;
        setError("");
        const error = validate();
        if (error) {
            alert(error);
            return;
        }        
        next({
            action: "submit_phone"
        });
    };
  

    const changeService = () => {
        if (loading) return;
        setError("");       
        navigate(
            `/start-waiver/${flowContext.businessLocationSlug}/${flowContext.businessTypeSlug}`
        );
    };

    const formatPhoneNumber = (value) => {
        const digits = (value || "").replace(/\D/g, "");
        if (digits.length <= 3) {
            return digits;
        }
        if (digits.length <= 6) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        }
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    };

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
                        
            <div className="guardian-page-header">
                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>
            </div>
            
            <div className="page-content guardian-phone-content">

                <div className="guardian-icon-circle">
                    <span className="guardian-person-icon">♙</span>
                    <span className="guardian-verified-icon">✓</span>
                </div>

                <h3 className="guardian-title">
                    Guardian Approval Required
                </h3>

                
                <p className="guardian-description">
                    {`${childFullName || "A Minor"} has asked you to review and approve their participation with ${
                        flowContext.business?.businessName || "this business"
                    }.`}
                </p>

                <p className="guardian-instruction">
                    Verify your mobile number to continue.
                </p>

                <div className="form-group guardian-phone-group">
                    <label>Mobile Number</label>

                    <input
                        type="tel"
                        value={formatPhoneNumber(flowData.phone)}
                        onChange={(e) => {
                            const digitsOnly = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);

                            updateFlowData({ phone: digitsOnly });
                        }}
                        placeholder="(555) 555-5555"
                        disabled={loading}
                    />
                </div>

                {error && (
                    <div className="text-red-600 mt-2">
                        {error}
                    </div>
                )}

            </div>


            <div className="page-footer guardian-phone-footer">

                <button
                    className="primary-button guardian-send-button"
                    onClick={continueToNext}
                    disabled={loading || !isFormValid}
                >
                    Send Verification Code
                    <span className="button-arrow">›</span>
                </button>

                <p className="guardian-consent-text">
                    Your phone number is used to verify your identity and
                    securely record your response. By continuing, you agree
                    to receive a one-time verification text. Message and data
                    rates may apply.
                </p>

                <div className="powered-by">
                    Powered by <strong>🟨 DidYouSign</strong>
                </div>

            </div>


        </div>
    );
}